// JWT payload fields we care about
export interface AuthUser {
  sub: string;
  email: string;
  first_name?: string;
  last_name?: string;
}

export function getStoredToken(): string | null {
  return localStorage.getItem('auth_token');
}

export function getAuthUser(): AuthUser | null {
  const token = getStoredToken();
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return {
      sub: payload.sub ?? '',
      email: payload.email ?? '',
      first_name: payload.first_name,
      last_name: payload.last_name,
    };
  } catch {
    return null;
  }
}

export function clearAuth(): void {
  localStorage.removeItem('auth_token');
}

export function isAuthenticated(): boolean {
  return getStoredToken() !== null && getAuthUser() !== null;
}
